import React from 'react';
import './TriggerInsights.css';

function TriggerInsights({ triggers }) {
  if (!triggers) return null;

  const { positiveCorrelations, negativeCorrelations, recommendations } = triggers;

  return (
    <div className="trigger-insights">
      <h3 className="trigger-insights__title">Emotional Triggers & Correlations</h3>

      {/* Positive Triggers */}
      {positiveCorrelations && positiveCorrelations.length > 0 && (
        <section className="trigger-insights__section">
          <div className="trigger-insights__section-header trigger-insights__section-header--positive">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <h4>What Lifts You Up</h4>
          </div>
          
          <div className="trigger-insights__cards">
            {positiveCorrelations.map((trigger, index) => (
            <div key={index} className="trigger-insights__card trigger-insights__card--positive">
              <div className="trigger-insights__card-header">
                <h5 className="trigger-insights__trigger-name">{trigger.trigger}</h5>
                <div className="trigger-insights__correlation">
                  <div className="trigger-insights__correlation-bar">
                    <div
                      className="trigger-insights__correlation-fill trigger-insights__correlation-fill--positive"
                      style={{ width: `${trigger.correlation * 100}%` }}
                    />
                  </div>
                  <span className="trigger-insights__correlation-value">
                    {((trigger.correlation || 0) * 100).toFixed(0)}%
                  </span>
                </div>
              </div>

              <div className="trigger-insights__impact">
                <div className="trigger-insights__impact-icon">↑</div>
                <div className="trigger-insights__impact-text">
                  <span className="trigger-insights__impact-value">
                    +{(trigger.averageMoodBoost || 0).toFixed(1)}
                  </span>
                  <span className="trigger-insights__impact-label">avg mood boost</span>
                </div>
              </div>

              <div className="trigger-insights__frequency">
                Occurred {trigger.frequency || 0} times
              </div>

              {trigger.examples && trigger.examples.length > 0 && (
                <div className="trigger-insights__examples">
                  <div className="trigger-insights__examples-label">Examples:</div>
                  <div className="trigger-insights__examples-tags">
                    {trigger.examples.map((example, i) => (
                      <span key={i} className="trigger-insights__example-tag">
                        {example}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
            ))}
          </div>
        </section>
      )}

      {/* Negative Triggers */}
      {negativeCorrelations && negativeCorrelations.length > 0 && (
      <section className="trigger-insights__section">
        <div className="trigger-insights__section-header trigger-insights__section-header--negative">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          <h4>What Brings You Down</h4>
        </div>
        
        <div className="trigger-insights__cards">
          {negativeCorrelations.map((trigger, index) => (
            <div key={index} className="trigger-insights__card trigger-insights__card--negative">
              <div className="trigger-insights__card-header">
                <h5 className="trigger-insights__trigger-name">{trigger.trigger}</h5>
                <div className="trigger-insights__correlation">
                  <div className="trigger-insights__correlation-bar">
                    <div
                      className="trigger-insights__correlation-fill trigger-insights__correlation-fill--negative"
                      style={{ width: `${Math.abs(trigger.correlation || 0) * 100}%` }}
                    />
                  </div>
                  <span className="trigger-insights__correlation-value">
                    {(Math.abs(trigger.correlation || 0) * 100).toFixed(0)}%
                  </span>
                </div>
              </div>

              <div className="trigger-insights__impact">
                <div className="trigger-insights__impact-icon">↓</div>
                <div className="trigger-insights__impact-text">
                  <span className="trigger-insights__impact-value">
                    {(trigger.averageMoodDrop || 0).toFixed(1)}
                  </span>
                  <span className="trigger-insights__impact-label">avg mood drop</span>
                </div>
              </div>

              <div className="trigger-insights__frequency">
                Occurred {trigger.frequency || 0} times
              </div>

              {trigger.examples && trigger.examples.length > 0 && (
                <div className="trigger-insights__examples">
                  <div className="trigger-insights__examples-label">Examples:</div>
                  <div className="trigger-insights__examples-tags">
                    {trigger.examples.map((example, i) => (
                      <span key={i} className="trigger-insights__example-tag">
                        {example}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
      )}

      {/* Recommendations */}
      {recommendations && recommendations.length > 0 && (
        <section className="trigger-insights__section">
          <div className="trigger-insights__section-header">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <h4>Personalized Recommendations</h4>
          </div>
          
          <div className="trigger-insights__recommendations">
            {recommendations.map((recommendation, index) => (
              <div key={index} className="trigger-insights__recommendation">
                <div className="trigger-insights__recommendation-icon">💡</div>
                <div className="trigger-insights__recommendation-text">
                  {recommendation}
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}

export default TriggerInsights;
